import React, { Suspense, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";

import SiteModal from "components/common/SiteModal/SiteModal";
import { ComponentSpinner } from "components/common/Spinner/LoadingSpinner";
import Router from "configs/router";
import { defaultSetting } from "core/data/default-setting";
import { UseGetSetting } from "core/services/api/getSetting";
import { correctUploadPath } from "core/utils/image-path-correction";
import { RootState } from "store/index";
import { setSetting } from "store/slices/setting";

const App = () => {
  const dispatch = useDispatch();

  const setting = useSelector((state: RootState) => state.setting);

  const { data }: any = UseGetSetting();

  useEffect(() => {
    if (!data?.data?.result) return;

    dispatch(
      setSetting({
        ...defaultSetting,
        ...data.data.result,
      }),
    );
  }, [data]);

  return (
    <>
      <Helmet>
        <title>{setting.name}</title>

        <link
          rel="icon"
          href={
            process.env.REACT_APP_PUBLIC_PATH +
            "/" +
            correctUploadPath(setting.logoImageAddress)
          }
        />
      </Helmet>

      <SiteModal />

      <Suspense fallback={<ComponentSpinner />}>
        <Router />
      </Suspense>
    </>
  );
};

export default App;
